module.exports = __webpack_public_path__ + "static/img/4-open5.7dadef9c.png";